import { render, staticRenderFns } from "./QuestionDescription.vue?vue&type=template&id=4126da60&scoped=true&"
import script from "./QuestionDescription.vue?vue&type=script&lang=js&"
export * from "./QuestionDescription.vue?vue&type=script&lang=js&"
import style0 from "./QuestionDescription.vue?vue&type=style&index=0&id=4126da60&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4126da60",
  null
  
)

export default component.exports